import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import ModalDialog from '@stubhub/react-modal-dialog';

import './index.scss';

const SESSION_VARIABLE_IDENTIFIER = 'intercept_modal';
const SESSION_VARIABLE_VALUE = 'skipped';

/**
 * Component which displays the Intercept Modal when Users from Canada access .com site
 * The modal will be dismissed once User clicks on below actions
 * Canada - Move to .ca site
 * U.S. - Stay in .com site
 * @prop {object} currentLocation [Required] Location of the Users actual location
 * @prop {string} defaultWebTLD [Required] The TLD accessed by users, for instance, com, ca etc
 */
class InterceptModal extends React.Component {
  static propTypes = {
    currentLocation: PropTypes.object.isRequired,
    defaultWebTLD: PropTypes.string.isRequired,
  };

  static defaultProps = {
    currentLocation: {},
    defaultWebTLD: 'com',
  };

  constructor(props) {
    super(props);
    this.state = {
      closeModal: false,
    };
  }

  /**
   * Click Handler when U.S. option is selected
   * Sets the session storage variable and updates the closeModal state for
   * the component to re-render to close the modal
   */
  continueWithUS = () => {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      window.sessionStorage.setItem(SESSION_VARIABLE_IDENTIFIER, SESSION_VARIABLE_VALUE);
    }
    this.setState({
      closeModal: true,
    });
  };

  /**
   * Method to read the session variable
   * @returns {string} TTL Date - 1 Year
   */
  getSessionValue = () => {
    let sessionValue = '';
    if (typeof window !== 'undefined' && window.sessionStorage) {
      sessionValue = window.sessionStorage.getItem(SESSION_VARIABLE_IDENTIFIER);
    }

    return sessionValue;
  };

  /**
   * Method to read the location from window.geo-location
   * @returns {Object} location Object with origin, pathname and search attributes
   */
  getLocation = () => {
    let location = {};
    if (typeof window !== 'undefined' && window.location) {
      let {origin, pathname, search} = window.location;
      location = {
        origin,
        pathname,
        search,
      };
    }

    return location;
  };

  /**
   * Method to Update window url to url sent
   * @param {string} URL Url of the page to be updated
   */
  setURL = (url) => {
    if (typeof window !== 'undefined' && window.location) {
      window.location.href = url;
    }
  };

  /**
   * Click Handler when Canada option is selected
   * Re-directs the users to .ca site
   */
  navigateToCA = () => {
    let location = this.getLocation();
    let url = `${location.origin && location.origin.replace('.com', '.ca')}${location.pathname}${location.search}`;
    this.setURL(url);
  };

  render() {
    let {currentLocation, defaultWebTLD} = this.props;
    let {closeModal} = this.state;
    let showModal =
      currentLocation.countryCode &&
      currentLocation.countryCode.toLowerCase() === 'ca' &&
      defaultWebTLD.toLowerCase() === 'com';
    let skippedModal = this.getSessionValue() === SESSION_VARIABLE_VALUE;

    return (
      <div>
        {showModal && !closeModal && !skippedModal ? (
          <ModalDialog className="InterceptModalDialog" closable={false} responsive>
            <div className="InterceptModal">
              <div className="InterceptModal__container">
                <div className="InterceptModal__title">
                  <FormattedMessage id="InterceptModal.title" defaultMessage={'Looks like you\'re located in Canada'} />
                </div>
                <div className="InterceptModal__subtitle">
                  <FormattedMessage
                    id="InterceptModal.subtitle"
                    defaultMessage="Where would you like to look for live events?"
                  />
                </div>
                <div className="InterceptModal__button" onClick={this.navigateToCA}>
                  <FormattedMessage id="InterceptModal.canadaOption" defaultMessage="Stubhub Canada" />
                </div>
                <div className="InterceptModal__button" onClick={this.continueWithUS}>
                  <FormattedMessage id="InterceptModal.usOption" defaultMessage="Stubhub U.S." />
                </div>
              </div>
            </div>
          </ModalDialog>
        ) : null}
      </div>
    );
  }
}

export default InterceptModal;
